// Polyfill for global object
if (typeof window !== 'undefined') {
  (window as any).global = window;
} 